import React from 'react';
import { Truck, Store, ShieldCheck, Key, Plane, Building, ChevronRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const iconMap = {
  truck: Truck,
  store: Store,
  'shield-check': ShieldCheck,
  key: Key,
  plane: Plane,
  building: Building
};

const Sectors = () => {
  const { content } = useLanguage();
  const { sectors, ui } = content;

  return (
    <section id="sectores" className="py-20 lg:py-32 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {ui.sectors.title}
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            {ui.sectors.subtitle}
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {sectors.map((sector) => {
            const Icon = iconMap[sector.icon];
            return (
              <AccordionItem
                key={sector.id}
                value={`item-${sector.id}`}
                className="bg-gradient-to-b from-gray-900 to-gray-950 border border-gray-800 rounded-2xl overflow-hidden hover:border-blue-600/50 transition-all duration-300"
              >
                <AccordionTrigger className="px-8 py-6 hover:no-underline">
                  <div className="flex items-center w-full">
                    <div className="w-12 h-12 bg-blue-600/10 rounded-lg flex items-center justify-center mr-4">
                      <Icon className="text-blue-400" size={24} />
                    </div>
                    <h3 className="text-xl font-semibold text-white text-left">
                      {sector.title}
                    </h3>
                    <div className="ml-auto flex items-center text-gray-400">
                      <span className="text-sm mr-2">{ui.sectors.benefitsLabel(sector.benefits.length)}</span>
                    </div>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-8 pb-6">
                  <div className="grid md:grid-cols-2 gap-4 mt-4">
                    {sector.benefits.map((benefit, index) => (
                      <div
                        key={index}
                        className="bg-gray-900/50 border border-gray-800 rounded-xl p-5 hover:border-blue-600/30 transition-colors duration-200"
                      >
                        <div className="flex items-start">
                          <ChevronRight className="text-blue-400 mr-2 flex-shrink-0 mt-1" size={18} />
                          <div>
                            <h4 className="text-white font-semibold mb-2 leading-snug">
                              {benefit.title}
                            </h4>
                            <p className="text-gray-400 text-sm leading-relaxed">
                              {benefit.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>

        {/* Bottom highlight */}
        <div className="mt-12 p-8 bg-gradient-to-r from-blue-950/30 to-gray-950/30 border border-blue-900/30 rounded-2xl text-center">
          <p className="text-lg text-gray-300">
            <span className="text-blue-400 font-semibold">{ui.sectors.highlightLabel}</span> {ui.sectors.highlightText}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Sectors;
